import React from 'react'
import { clsx } from 'clsx'

interface DashboardCardProps {
  title: string
  children?: React.ReactNode
  className?: string
  onClick?: () => void
  // Stats card props
  value?: string
  icon?: React.ReactNode
  subtitle?: string
  variant?: 'default' | 'success' | 'warning' | 'error'
}

export const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  children,
  className,
  onClick,
  value,
  icon,
  subtitle,
  variant = 'default'
}) => {
  // If this is a stats card (has value prop), render stats layout
  if (value !== undefined) {
    return (
      <div 
        className={clsx(
          'card-thai',
          onClick && 'cursor-pointer hover:shadow-md transition-shadow',
          variant === 'success' && 'border-green-200 bg-green-50',
          variant === 'warning' && 'border-yellow-200 bg-yellow-50',
          variant === 'error' && 'border-red-200 bg-red-50',
          className
        )}
        onClick={onClick}
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">{title}</p>
            <p className={clsx(
              "text-2xl font-bold",
              variant === 'success' && 'text-green-600',
              variant === 'warning' && 'text-yellow-600',
              variant === 'error' && 'text-red-600',
              variant === 'default' && 'text-gray-900'
            )}>
              {value} {subtitle && <span className="text-sm font-normal text-gray-500">{subtitle}</span>}
            </p>
          </div>
          {icon && (
            <div className={clsx(
              "p-2 rounded-lg",
              variant === 'success' && 'bg-green-100 text-green-600',
              variant === 'warning' && 'bg-yellow-100 text-yellow-600',
              variant === 'error' && 'bg-red-100 text-red-600',
              variant === 'default' && 'bg-gray-100 text-gray-600'
            )}>
              {icon}
            </div>
          )}
        </div>
      </div>
    )
  }

  // Regular card layout
  return (
    <div 
      className={clsx(
        'card-thai',
        onClick && 'cursor-pointer hover:shadow-md transition-shadow',
        className
      )}
      onClick={onClick}
    >
      <div className="card-header-thai">
        {title}
      </div>
      <div className="card-content-thai">
        {children}
      </div>
    </div>
  )
}